export const about = {
  "about.title": "À propos de Suji",
  "about.subtitle": "La plateforme de référence pour connecter les entreprises avec les meilleurs fournisseurs du Nigeria",
  "about.mission_title": "Notre Mission",
  "about.mission_text1": "Suji révolutionne la façon dont les entreprises trouvent et se connectent avec les fournisseurs au Nigeria. Notre plateforme géolocalisée permet de découvrir facilement les meilleurs partenaires commerciaux dans tout le pays.",
  "about.mission_text2": "Nous croyons en la puissance de l'économie nigériane et nous nous engageons à faciliter les connexions qui stimulent la croissance des entreprises locales.",
  "about.stat_suppliers": "Fournisseurs actifs",
  "about.stat_states": "États couverts",
  "about.mission_image_alt": "Professionnels d'affaires nigérians collaborant",
  "about.values_title": "Nos Valeurs",
  "about.values_subtitle": "Les principes qui guident notre travail et notre engagement envers la communauté des affaires nigériane",
  "about.value_transparency_title": "Transparence",
  "about.value_transparency_text": "Chez SUJI, nous mettons un point d'honneur à fournir des informations claires et utiles pour vous aider à prendre les bonnes décisions. Tous les contacts ne sont pas systématiquement vérifiés, mais nous vous donnons les outils et orientations pour avancer en toute lucidité. Vous gardez le contrôle de vos décisions.",
  "about.value_access_title": "Accessibilité",
  "about.value_access_text": "Nous rendons le marché nigérian simple et accessible à tous. Entrepreneurs, commerçants ou investisseurs, SUJI vous connecte facilement aux opportunités locales. Le Nigeria devient accessible, sans complexité.",
  "about.value_efficiency_title": "Efficacité",
  "about.value_efficiency_text": "Nous vous faisons gagner du temps en vous orientant vers les bonnes pistes. Notre objectif : réduire vos efforts de recherche et accélérer vos résultats. Moins de recherches, plus d'actions.",
  "about.team_title": "Notre Équipe",
  "about.team_subtitle": "Des experts passionnés par le développement de l'écosystème entrepreneurial nigérian",
  "about.team_ceo": "CEO & Fondateur",
  "about.team_cto": "Directrice Technique",
  "about.team_cco": "Directeur Commercial",
  "about.our_leadership_label": "Notre Leadership",
  "about.cta_title": "Rejoignez la communauté Suji",
  "about.cta_subtitle": "Que vous soyez fournisseur ou acheteur, découvrez comment Suji peut transformer votre activité",
  "about.cta_become_supplier": "Devenir fournisseur",
  "about.cta_search_suppliers": "Rechercher des fournisseurs",
  "about.add_business": "Ajouter votre entreprise",
  "about.badge_story": "Notre Histoire",
  "about.badge_mission": "Notre Mission"
};

export default about;
